import { DomainEvent } from './DomainEvent'

export class TenantCreated extends DomainEvent {
  readonly eventType = 'tenant.created' as const
  constructor(
    aggregateId: string,
    public readonly slug: string,
    public readonly name: string,
    public readonly ownerUserId: string,
  ) { super(aggregateId) }
}
